<td class>
    <select class="form-select float-left width-120" aria-label="Status select" [(ngModel)]="currentStatus">
    <option *ngFor="let status of inputList" value="{{status.id}}" [selected]="status.attributes.name == currentStatus">{{ status.attributes.name }}</option>
    </select>
    <button class="btn btn-color" (click)="getStatus()" title="save"><i class="bi bi-check-circle"></i></button>
</td>